import { render, staticRenderFns } from "./GraphDetail42.vue?vue&type=template&id=27945ee8&scoped=true"
import script from "./GraphDetail42.vue?vue&type=script&lang=js"
export * from "./GraphDetail42.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27945ee8",
  null
  
)

export default component.exports